<template>
  <main>
    <SectionHero>
      <OrganismHero :hero="hero" />
      <template #footerShort>
        <div class="flex flex-col flex-1 gap-y-3 md:flex-row gap-x-[10px] justify-between">
          <div class="flex flex-col flex-1 gap-y-3 md:flex-row gap-x-[10px] md:items-end">
            <div>
              <AtomButtonDropdown
                class="-md:w-full"
                hide-sup
                :items="cityItems"
                :initial-index="initialCity"
                @select="onCitySelect"
              />
            </div>
            <div class="flex md:items-end">
              <AtomButtonDropdown
                class="-md:w-full"
                :items="clubItems"
                :initial-index="initialClub"
                @select="onClubSelect"
              />
            </div>
          </div>
          <!-- <div class="flex items-end">
            <AtomButtonDropdown
              class="-md:w-full"
              small
              theme-light
              :items="clubItems"
              :initial-index="initialClub"
              @select="onClubSelect"
            />
          </div> -->
        </div>
      </template>
    </SectionHero>
    <SectionDefault>
      <NuxtChild :context="{ club: $route.params.club || clubItems[0].slug }" />
    </SectionDefault>
  </main>
</template>

<script>
import AtomButtonDropdown from '../../components/atoms/AtomButtonDropdown'
import pageBuilder from '../../components/mixins/pageBuilder.js'
import OrganismHero from '../../components/organisms/layouts/OrganismHero'
import SectionDefault from '../../components/templates/layouts/SectionDefault'
import SectionHero from '../../components/templates/layouts/SectionHero'

const mixinPageBuilder = pageBuilder({
  pageUrl: 'trainers',
})

export default {
  name: 'Team',
  components: {
    SectionDefault,
    SectionHero,
    OrganismHero,
    AtomButtonDropdown,
  },
  mixins: [mixinPageBuilder],
  meta: {
    theme: 'dark',
  },
  data: c => {
    return {
      cityId: null,
      hero: {
        title1: 'encore',
        title2: 'team',
        desc: 'Encore Team&nbsp;&mdash; это ведущие эксперты индустрии. Для нас фитнес&nbsp;&mdash; это не&nbsp;просто работа, а&nbsp;отношение к&nbsp;жизни.',
        breadcrumbs: c.$breadcrumbs.trainers(),
      },
    }
  },
  computed: {
    clubs() {
      return this.$store.getters['modules/content/clubs']
    },
    cityGeoId() {
      return this.$store.getters['modules/content/geoposition'].id
    },
    clubItems() {
      const cityId = this.cityId
      return this.clubs.filter(club => club.city.id == cityId).map(club => ({ text: club.title, slug: club.slug }))
    },
    cityItems() {
      return this.$store.getters['modules/content/getClubsTownsAsDropdown']
    },
    initialCity() {
      const club = this.clubs.find(club => club.slug == this.$route.params.club)
      if (club) {
        return this.cityItems.findIndex(({ cityId }) => cityId == club.city.id)
      }
      const indexByGeo = this.cityItems.findIndex(({ cityId }) => cityId == this.cityGeoId)
      return indexByGeo === -1 ? 0 : indexByGeo
    },
    initialClub() {
      const initial = this.clubItems.findIndex(({ slug }) => slug == this.$route.params.club)
      return initial === -1 ? 0 : initial
    },
  },
  created() {
    this.cityId = this.cityItems[this.initialCity].cityId
  },
  beforeMount() {
    if (!this.$route.params.club) {
      const club = this.$store.getters['modules/content/geopositionClub']
      this.$router.replace(`/team/${club.slug}`)
    }
  },
  methods: {
    onCitySelect(i) {
      const city = this.cityItems[i]
      this.cityId = city.cityId
    },
    onClubSelect(i) {
      const club = this.clubItems[i]
      if (this.$route.params.club === club.slug) return
      this.$router.push(`/team/${club.slug}`)
    },
  },
}
</script>
